import styled from 'styled-components';
import { NEUTRAL_900, PALE_BLUE, VIOLET_600 } from "@styles/colors";
import { GIVONIC, INTER } from "@styles/fonts";
import { WHITE } from "@styles/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  align-items: center;
  background-color: ${PALE_BLUE};
  padding: 35% 12px 12px 12px;
  gap: 32px;
`;

export const BackgroundImage = styled.img`
  position: absolute;
  top: 10%;
  width: 100%;
  height: 100vw;
  aspect-ratio: 1;
  z-index: 1;
`;

export const StatusIconWrapper = styled.div`
  z-index: 2;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const Title = styled.span`
  font-family: ${GIVONIC.black};
  color: ${VIOLET_600};
  font-size: 18px;
`;

export const Subtitle = styled.span`
  font-family: ${INTER.regular};
  color: ${NEUTRAL_900};
  font-size: 14px;
  text-align: center;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  z-index: 2;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 12px 24px 12px;
  width: 100%;
  background-color: ${WHITE};
`;
